module.exports = __webpack_public_path__ + "img/icon-withdrawal.986d30c7.svg";